import { render, staticRenderFns } from "./pinned_section.vue?vue&type=template&id=a0cb705a"
import script from "./pinned_section.vue?vue&type=script&lang=js"
export * from "./pinned_section.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports